import React, { useEffect, useState } from 'react'
import { CustomButton, FilterBar, TableData } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { setBalanceReport } from '../../redux/slices/report/reportSlice';
import { downloadBalanceReportService, getBalanceReportService } from '../../services/report/reportService';
import { errorAlert } from '../../helpers/alerts';
import { currencyFormatter, downloadFile } from '../../helpers/util';
import { getCommercesService, getDeepCommercesService } from 'services/client/commerceService';
import { setTitle } from 'redux/slices/uiSlice';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import Images from 'assets/images';
import Image from 'components/common/Image';
import moment from 'moment';

const BalancesScreen = () => {
  const dispatch = useDispatch();
  const { hoster, bags } = useSelector(store => store.session);
  const { balanceReport } = useSelector(store => store.reports);
  const [loading, setLoading] = useState(false)
  const [downloadFilters, setDownloadFilters] = useState({})
  const [commerces, setCommerces] = useState(null)
  const [all_commerce, set_all_commerce] = useState(false)
  useEffect(() => {
    dispatch(setTitle('Reporte de Saldos'));
  }, []);

  useEffect(() => {
    // if (hoster) return;
    if (all_commerce) {
      getDeepCommercesService(undefined, true)
        .then((response) => setCommerces(response))
        .catch((e) => errorAlert(e))
    } else {
      getCommercesService(undefined, true)
        .then((response) => setCommerces(response))
        .catch((e) => errorAlert(e))
    }

    // eslint-disable-next-line
  }, [balanceReport, all_commerce]);

  const handlerSubmit = async (data) => {
    if (!data.commerce || !data.type) return;
    setLoading(true)
    setDownloadFilters(data)
    getBalanceReportService(data)
      .then((response) => dispatch(setBalanceReport(response || [])))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false));
  }

  const handlerDownload = async () => {
    if (!downloadFilters.commerce || !downloadFilters.type) return;
    setLoading(true)
    downloadBalanceReportService(downloadFilters)
      .then((data) => downloadFile(data, 'Reporte de Saldos.xlsx'))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false));
  }

  const sortedCommerces = commerces ? [...commerces].sort((a, b) => {
    const order = { 'H2H': 1, 'DISTRIBUIDOR': 2, 'MENUDEO': 3 };
    return order[a.type_commerce] - order[b.type_commerce];
  }) : [];

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        defaultValues={{
          date: [new Date(), new Date()],
        }}
        filters={[
          {
            type: "dates",
            name: "date",
            label: "Fecha",
          },
          {
            name: 'commerce',
            label: "Comercio",
            type: "select",
            data: sortedCommerces?.map((item) => ({ id: item._id, name: item.username })) || [],
            loading: commerces == null
          },
          {
            name: 'type',
            label: "Tipo",
            type: "select",
            data: hoster ? bags.map(item => ({ id: item.type, name: item.type })) : [
              { id: 'TAE', name: "TAE" },
              { id: 'PDS', name: "PDS" },
            ],
          },
        ]}
      />
      <Box >
        <TableData
          loading={loading}
          headerButtons={[
            <FormControlLabel
              label={'Todos los comercios'}
              control={
                <Checkbox
                  checked={all_commerce}
                  checkedIcon={<Image src={Images.icon.check_square} />}
                  icon={<Image src={Images.icon.uncheck_square} />}
                  onChange={(e) => {
                    set_all_commerce(e.target.checked)
                  }}
                />
              }
            />,
            <CustomButton
              dark={true}
              icon={Images.icon.download}
              key="dowloadBalance"
              name={"Descargar"}
              click={handlerDownload}
            />,
          ]}
          dataRows={balanceReport.map((item) => ({
            ...item,
            collapsible: item?.children?.length > 0 && item.children.map((item) => ({
              ...item,
              collapsible: item?.children?.length > 0 && item.children,
            })),
          }))}
          rowsPerPageOpt={500}
          dataTitle={[
            "Fecha",
            "Id Comercio",
            "Comercio",
            "Bolsa",
            "Saldo inicial",
            "Abonos",
            "Ventas",
            "Saldo final",
          ]}
          formatter={({ date, hosterIdentification, hoster, bag, bagType, balance, payment, sale }) => ([
            moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            hosterIdentification,
            hoster,
            bagType,
            currencyFormatter.format(balance || 0),
            currencyFormatter.format(payment || 0),
            currencyFormatter.format(sale || 0),
            currencyFormatter.format(balance + payment + sale || 0),
          ])}
        />
      </Box>
    </>

  )
}

export default BalancesScreen